"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PassportFilesControl = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _v = _interopRequireDefault(require("uuid/v4"));
var _Alert = _interopRequireWildcard(require("../../../../../../../ui/Alert"));
var _Button = _interopRequireWildcard(require("../../../../../../../ui/Button"));
var _InputFile = require("../../../../../../../ui/InputFile");
var _selectors = require("../../../../../../../../bus/ui/selectors");
var _actions = require("../../store/actions");
var _passport = _interopRequireDefault(require("./passport.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var noop = function noop() {};
var PassportFilesControlPure = function PassportFilesControlPure(_ref) {
  var error = _ref.error,
    _ref$onPassportLoaded = _ref.onPassportLoaded,
    onPassportLoaded = _ref$onPassportLoaded === void 0 ? noop : _ref$onPassportLoaded,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? noop : _ref$onError;
  var uiKey = (0, _react.useMemo)(function () {
    return "".concat((0, _v.default)(), "_RECOGNIZE_PASSPORT_UI");
  }, []);
  var ui = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getUI)(state, {
      key: uiKey
    });
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('BOOKING_FORM_BY_OPERATOR'),
    t = _useTranslation.t;
  var onFileChange = (0, _react.useCallback)(function (file) {
    dispatch(_actions.bookingActions.recognizePassport(uiKey, file, onPassportLoaded));
  }, [dispatch, uiKey, onPassportLoaded]);
  var errorMsg = error || ui.error;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InputFile.InputFile, {
    onChange: onFileChange,
    onError: onError,
    trigger: /*#__PURE__*/_react.default.createElement(_Button.default, {
      loading: ui.loading,
      icon: _passport.default,
      fontFamily: _Button.FONT_FAMILIES.REGULAR
    }, t('BOOKING_RECOGNIZE_FILE_BUTTON'), "...")
  }), errorMsg && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    type: _Alert.TYPES.ERROR
  }, errorMsg));
};
PassportFilesControlPure.propTypes = {
  error: _propTypes.default.string,
  onPassportLoaded: _propTypes.default.func,
  onError: _propTypes.default.func
};
var PassportFilesControl = exports.PassportFilesControl = (0, _react.memo)(PassportFilesControlPure);